import { postRequest } from "src/utils";

const { REACT_APP_WB_BACKEND: URL_BACKEND } = process.env;

export const postFreezersGenerateMudmapReq = (data: any) =>
	postRequest(`${URL_BACKEND}/freezers/mudmap`, data, {}, "multipart/form-data");

export const postFreezersGeneratePlanogramReq = (data: any) =>
	postRequest(`${URL_BACKEND}/freezers/planogram`, data, {}, "multipart/form-data");
